import React from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { lightTable } from "../../../../../../../styles/muiProps";
import DocTransmittalSubRow from "../SubRow";
import { docTransmittalCols } from "./cols";
import { getLatestRows } from "../utils/getLatestRows";
import { useDocTransmittalContext } from "../DocTransmittal.context";

export default function DocTransmittalTable({ to, isArchived, closed }) {
  const { allDocTransmittals } = useDocTransmittalContext();

  // const filteredData = getLatestRows(allDocTransmittals, "docNumber", "date");
  const allData = closed
    ? []
    : isArchived
    ? allDocTransmittals
    : allDocTransmittals;

  const data = () => {
    switch (to) {
      case "Receiver":
        return allData;

      case "Client":
        return allData.filter((d) => d.customer?.id);

      case "Vendor":
        return allData.filter((d) => d.vendor?.id);

      default:
        return [];
    }
  };

  const archivedDetails = isArchived
    ? {
        enableGrouping: true,
        enableColumnDragging: false,
        initialState: { grouping: ["docNumber"] },
        groupedColumnMode: false,
      }
    : {};

  /////-------- Table --------------
  const table = useMaterialReactTable({
    data: data(),
    columns: docTransmittalCols(to, isArchived),
    ...lightTable,
    enableExpanding: true,

    ...archivedDetails,

    renderDetailPanel: ({ row }) => <DocTransmittalSubRow row={row.original} />,
  });

  return <MaterialReactTable table={table} />;
}
